/** Short display labels for OASIS visit type IDs. */
export const OASIS_VISIT_TYPE_LABELS: Record<string, string> = {
  OASIS_E2_START_OF_CARE: 'SOC',
  OASIS_E2_RESUMPTION_OF_CARE: 'ROC',
  OASIS_E2_RECERTIFICATION: 'REC',
  OASIS_E2_DISCHARGE: 'DC',
  OASIS_E2_START_OF_CARE_PT: 'SOC (PT)',
  OASIS_E2_RESUMPTION_OF_CARE_PT: 'ROC (PT)',
  OASIS_E2_RECERTIFICATION_PT: 'REC (PT)',
  OASIS_E2_DISCHARGE_PT: 'DC (PT)',
  OASIS_E2_START_OF_CARE_OT: 'SOC (OT)',
  OASIS_E2_RESUMPTION_OF_CARE_OT: 'ROC (OT)',
  OASIS_E2_RECERTIFICATION_OT: 'REC (OT)',
  OASIS_E2_DISCHARGE_OT: 'DC (OT)',
  OASIS_E2_START_OF_CARE_ST: 'SOC (ST)',
  OASIS_E2_RESUMPTION_OF_CARE_ST: 'ROC (ST)',
  OASIS_E2_RECERTIFICATION_ST: 'REC (ST)',
  OASIS_E2_DISCHARGE_ST: 'DC (ST)',
};
